"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.partialRecipeEditMutationOptions = exports.partialRecipeEditMutation = void 0;
const client_1 = require("@apollo/client");
exports.partialRecipeEditMutation = client_1.gql `
  mutation PartialRecipeEdit($id: String!, $input: PartialRecipe!) {
    partialRecipeEdit(id: $id, input: $input) {
      recipe {
        id
        rating
      }
    }
  }
`;
exports.partialRecipeEditMutationOptions = (variables) => ({
    variables,
    optimisticResponse: {
        __typename: "Mutation",
        partialRecipeEdit: {
            __typename: "RecipeResponse",
            recipe: {
                __typename: "Recipe",
                id: variables.id,
                rating: variables.input.rating,
            },
        },
    },
});
//# sourceMappingURL=partialRecipeEdit.js.map